export default "__VITE_ASSET__wQPjYTTp__"